
import React, { Component } from "react";
import { Row, Col, Spin, Select } from "antd";
import {
  FormItem,
  SelectItem,
  InputItem,
  InputNumberItem,
  HeaderItem,
  BoxItem,
  ModalItem,
  ButtonItem,
} from "./Items";
import { EditOutlined, EnvironmentOutlined } from "@ant-design/icons";

const { Option } = Select;

class TabEntregaDireccion extends Component {
  state = {
    modalVisible: false,
    direccionEntrega: null, // re-renders
  };

  abrirModal = () => this.setState({ modalVisible: true });
  cerrarModal = () => this.setState({ modalVisible: false });

  guardarCambios = () => {
    // Verificar que formInstance exista y esté montado antes de acceder
    if (this.props.formInstance?.formRef?.current) {
      // Leer dirección actual del formulario principal
      const direccionEntregaValues = this.props.formInstance.getFieldValue('direccionEntrega');
      
      // Actualizar state local para disparar re-render inmediato
      this.setState({ 
        modalVisible: false,
        direccionEntrega: direccionEntregaValues 
      });
      
      // Notificar al padre (AgregarVenta) sobre el cambio
      if (this.props.onDireccionChange && direccionEntregaValues) {
        this.props.onDireccionChange(direccionEntregaValues);
      }
    } else {
      this.setState({ modalVisible: false });
    }
  };

  componentDidMount() {
    // Al montar, cargar dirección inicial desde el formulario si existe
    if (this.props.formInstance?.formRef?.current) {
      const direccionEntrega = this.props.formInstance.getFieldValue('direccionEntrega');
      if (direccionEntrega) {
        this.setState({ direccionEntrega });
      }
    }
  }

  componentDidUpdate(prevProps) { // Detectar cambios en props para sincronizar state local
    // Salir si el formulario no está disponible
    if (!this.props.formInstance?.formRef?.current) {
      return;
    }

    // resetear/actualizar dirección
    if (prevProps.clienteDireccion !== this.props.clienteDireccion) {
      const direccionEntrega = this.props.formInstance.getFieldValue('direccionEntrega');
      this.setState({ direccionEntrega });
      return;
    }

    // Dirección cambió desde otro componente (ej: selector)
    if (!this.state.modalVisible) {
      const direccionEntrega = this.props.formInstance.getFieldValue('direccionEntrega');
      const direccionEntregaStr = JSON.stringify(direccionEntrega);
      const stateStr = JSON.stringify(this.state.direccionEntrega);

      // Comparar JSON para detectar cambios profundos
      if (direccionEntregaStr !== stateStr) {
        this.setState({ direccionEntrega });
      }
    }
  }

  // Formatea dirección estilo Google Maps: "Calle 123, Colonia, CP Ciudad, Estado"
  formatDireccionGoogleMaps = (direccion, municipio, estado, cp) => {
    const partes = [];

    // Calle y número
    if (direccion?.calle) {
      const calleCompleta = `${direccion.calle}${direccion.numeroCalle ? ' ' + direccion.numeroCalle : ''}`;
      partes.push(calleCompleta);
    }

    // Colonia
    if (direccion?.colonia) {
      partes.push(direccion.colonia);
    }

    // CP + Municipio
    const ciudadParte = [];
    if (cp) ciudadParte.push(cp);
    if (municipio) ciudadParte.push(municipio);
    if (ciudadParte.length > 0) {
      partes.push(ciudadParte.join(' '));
    }

    // Estado
    if (estado) {
      partes.push(estado);
    }

    return partes.filter(Boolean).join(', ');
  }

  render() {
    const { loadingEntrega, readOnly = false, clienteDireccion, objetoMunicipios, objetoEstados, objetoPlantasEntrega } = this.props;
    const direccionEntrega = this.state.direccionEntrega || this.props.direccionEntrega;
    
    const layoutFull = { labelCol: { span: 4 }, wrapperCol: { span: 20 } };
    const layoutHalf = { labelCol: { span: 8 }, wrapperCol: { span: 16 } };
    
    // Dirección fiscal = primera dirección del cliente
    const direccionFiscal = clienteDireccion;

    const getOptionText = (optionsArray, id) => {
      if (!optionsArray || !id) return null;
      const option = Array.isArray(optionsArray) 
        ? optionsArray.find(opt => opt?.key === id)
        : null;
      return option?.props?.children || null; // Extrae el texto del children
    };

    // Convertir IDs → Nombres para dirección de entrega
    const plantaEntregaNombre = getOptionText(objetoPlantasEntrega?.["direccionEntrega"], direccionEntrega?.plantaEntregaId);
    const direccionEntregaMunicipio = getOptionText(objetoMunicipios, direccionEntrega?.municipioId);
    const direccionEntregaEstado = getOptionText(objetoEstados, direccionEntrega?.estadoId);
    const direccionEntregaCP = direccionEntrega?.coloniaId?.codigoPostal || null;

    // Convertir IDs → Nombres para dirección fiscal (con fallback a objetos poblados)
    const direccionFiscalMunicipio = direccionFiscal?.municipio?.nombre || getOptionText(objetoMunicipios, direccionFiscal?.municipioId);
    const direccionFiscalEstado = direccionFiscal?.estado?.nombre || getOptionText(objetoEstados, direccionFiscal?.estadoId);


    return (
      <>
        {/* Vista cuando no hay cliente asignado */}
        <div style={{ padding: '20px', background: 'white', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)', border: '2px solid #f0f0f0' }}>
          <Row gutter={[24, 16]}>
            {/* DIRECCIÓN FISCAL */}
            <Col span={12} xs={24} sm={24} lg={12}>
            {!direccionFiscal ? (
              <div style={{ padding: '20px', background: '#fafafa', borderRadius: '8px', border: '2px dashed #e8e8e8', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '200px' }}>
                <EnvironmentOutlined style={{ fontSize: '32px', color: '#e8e8e8', marginBottom: '12px' }} />
                <div style={{ fontSize: '14px', fontWeight: 600, color: '#999', marginBottom: '12px' }}>
                  Sin dirección fiscal asignada
                </div>
                {!readOnly && (
                  <div style={{ fontSize: '14px', fontWeight: 800, color: "#00BFD6", marginBottom: '12px' }}>
                    Asignar Cliente para añadir dirección
                  </div>
                )}
              </div>
            ) : (
              <>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px', paddingBottom: '12px', borderBottom: '1px solid #f0f0f0' }}>
                  <EnvironmentOutlined style={{ fontSize: '18px', color: '#1890ff' }} />
                  <span style={{ fontSize: '16px', fontWeight: 600, color: '#333' }}>Dirección Fiscal</span>
                </div>
                <Row gutter={[12, 12]}>
                  {/* DATOS FISCALES */}
                  <Col span={16}>
                    <div style={{ fontSize: '13px', color: '#999', marginBottom: '8px', fontWeight: 600 }}>DATOS</div>
                    <div style={{ fontSize: '13px', color: '#333', lineHeight: '1.6' }}>
                      {this.formatDireccionGoogleMaps(
                        direccionFiscal,
                        direccionFiscalMunicipio,
                        direccionFiscalEstado,
                        direccionFiscal.coloniaId?.codigoPostal
                      )}
                    </div>
                    {direccionFiscal.numeroInterior && (
                      <div style={{ fontSize: '12px', color: '#666' }}>
                        Interior: {direccionFiscal.numeroInterior}
                      </div>
                    )}
                  </Col>

                  {/* CONTACTO FISCAL */}
                  <Col span={8}>
                    <div style={{ fontSize: '13px', color: '#999', marginBottom: '8px', fontWeight: 600 }}>CONTACTO</div>
                    <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
                      {direccionFiscal.descripcion && <span><strong>Nombre:</strong> {direccionFiscal.descripcion}</span>}
                      {direccionFiscal.descripcion && direccionFiscal.telefono && <span> | </span>}
                      {direccionFiscal.telefono && <span><strong>Tel:</strong> {direccionFiscal.telefono}</span>}
                    </div>
                    {direccionFiscal.correo && (
                      <div style={{ fontSize: '12px', color: '#666' }}>
                        <strong>Email:</strong> {direccionFiscal.correo}
                      </div>
                    )}
                  </Col>
                </Row>
              </>
            )}
            </Col>

            {/*  DIRECCIÓN DE ENTREGA */}
            <Col span={12} xs={24} sm={24} lg={12}>
              {!direccionEntrega ? (
                <div style={{ padding: '20px', background: '#fafafa', borderRadius: '8px', border: '2px dashed #e8e8e8', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '200px' }}>
                  <EnvironmentOutlined style={{ fontSize: '32px', color: '#e8e8e8', marginBottom: '12px' }} />
                  <div style={{ fontSize: '14px', fontWeight: 600, color: '#999', marginBottom: '12px' }}>
                    Sin dirección de entrega asignada
                  </div>
                  {!readOnly && (
                    <ButtonItem type="primary" icon={<EditOutlined />} onClick={this.abrirModal} size="small" cyan>
                      Asignar Dirección
                    </ButtonItem>
                  )}
                </div>
              ) : (
                <>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', paddingBottom: '12px', borderBottom: '1px solid #f0f0f0' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <EnvironmentOutlined style={{ fontSize: '18px', color: '#C9DF00' }} />
                      <span style={{ fontSize: '16px', fontWeight: 600, color: '#333' }}>Dirección de Entrega</span>
                    </div>
                    {!readOnly && (
                      <ButtonItem type="primary" icon={<EditOutlined />} onClick={this.abrirModal} size="small" cyan>
                        Editar
                      </ButtonItem>
                    )}
                  </div>
                  
                  <Row gutter={[12, 12]}>
                    {/* DATOS DE ENTREGA */}
                    <Col span={16}>
                      <div style={{ fontSize: '13px', color: '#999', marginBottom: '8px', fontWeight: 600 }}>DATOS</div>

                      {direccionEntrega?.clienteNombre && (
                        <div style={{ fontSize: '12px', color: '#666', marginBottom: '6px' }}>
                          <strong>Cliente:</strong> {direccionEntrega.clienteNombre}
                        </div>
                      )}

                      {direccionEntrega?.clienteRfc && (
                        <div style={{ fontSize: '12px', color: '#666', marginBottom: '6px' }}>
                          <strong>RFC:</strong> {direccionEntrega.clienteRfc}
                        </div>
                      )}

                      {direccionEntrega?.referencia && (
                        <div style={{ fontSize: '12px', color: '#666', marginBottom: '6px' }}>
                          <strong>Ref:</strong> {direccionEntrega.referencia}
                        </div>
                      )}

                      {direccionEntrega?.destino && (
                        <div style={{ fontSize: '12px', color: '#666', marginBottom: '6px' }}>
                          <strong>Destino:</strong> {direccionEntrega.destino}
                        </div>
                      )}

                      {direccionEntrega?.embarque && (
                        <div style={{ fontSize: '12px', color: '#666', marginBottom: '6px' }}>
                          <strong>Embarque:</strong> {direccionEntrega.embarque}
                        </div>
                      )}

                      {plantaEntregaNombre && (
                        <div style={{ fontSize: '12px', color: '#666', marginBottom: '6px' }}>
                          <strong>Planta de Entrega:</strong> {plantaEntregaNombre}
                        </div>
                      )}

                      <div style={{ fontSize: '13px', color: '#333', lineHeight: '1.6', marginBottom: '6px' }}>
                        {this.formatDireccionGoogleMaps(
                          direccionEntrega,
                          direccionEntregaMunicipio,
                          direccionEntregaEstado,
                          direccionEntregaCP
                        )}
                      </div>

                      {direccionEntrega?.numeroInterior && (
                        <div style={{ fontSize: '12px', color: '#666' }}>
                          Interior: {direccionEntrega.numeroInterior}
                        </div>
                      )}
                    </Col>

                    {/* CONTACTO DE ENTREGA */}
                    <Col span={8}>
                      <div style={{ fontSize: '13px', color: '#999', marginBottom: '8px', fontWeight: 600 }}>CONTACTO</div>
                      <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
                        {direccionEntrega?.descripcion && <span><strong>Nombre:</strong> {direccionEntrega.descripcion}</span>}
                        {direccionEntrega?.descripcion && direccionEntrega?.telefono && <span> | </span>}
                        {direccionEntrega?.telefono && <span><strong>Tel:</strong> {direccionEntrega.telefono}</span>}
                      </div>
                      {direccionEntrega?.correo && (
                        <div style={{ fontSize: '12px', color: '#666' }}>
                          <strong>Email:</strong> {direccionEntrega.correo}
                        </div>
                      )}
                      {direccionEntrega?.observaciones && (
                        <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                          <strong>Observaciones:</strong> {direccionEntrega.observaciones}
                        </div>
                      )}
                    </Col>
                  </Row>
                </>
              )}
            </Col>
          </Row>
        </div>

        {/* Modal con todos los campos - Solo se muestra si NO es readOnly */}
          <ModalItem
          title="Asignar Dirección de Entrega"
          visible={this.state.modalVisible}
          onCancel={this.cerrarModal}
          onOk={this.guardarCambios}
          footer={true}
          okText="Aceptar"
          cancelText="Cancelar"
          width="1300px"
          spinning={loadingEntrega}
          forceRender
        >
          <Spin spinning={loadingEntrega}>
            <Row gutter={16}>
              <Col span={24}>
                <FormItem 
                  noStyle 
                  shouldUpdate={(prev, curr) => prev.clienteId !== curr.clienteId}
                >
                  {({ getFieldValue }) => {
                    const clienteId = getFieldValue('clienteId');
                    if (clienteId) {
                      return (
                        <FormItem
                          label="Direcciones Cliente"
                          name="direccionEntregaId"
                          margin
                          labelCol={{ span: 4 }}
                          wrapperCol={{ span: 20 }}
                        >
                          <SelectItem 
                            placeholder="Direcciones Cliente" 
                            onChange={this.props.handleChangeDireccionEntrega}
                          >
                            {this.props.objetoDireccionesCliente}
                          </SelectItem>
                        </FormItem>
                      )
                    }
                  }}
                </FormItem>
              </Col>
            </Row>
            <Row gutter={16}>
              {/* SECCIÓN DIRECCIÓN */}
              <Col span={12} xs={24} lg={12}>
                <HeaderItem>DIRECCIÓN</HeaderItem>
                <BoxItem>
                  <Row gutter={8}>
                    <Col span={12}>
                      <FormItem
                        name={["direccionEntrega", "clienteNombre"]}
                        label="Cliente"
                        max={200}
                        margin
                        pattern
                        tooltip="Nombre del cliente para esta dirección (extranjero)"
                        {...layoutHalf}
                      >
                        <InputItem placeholder="Ej: ACME EUROPE B.V." width="100%" />
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem
                        name={["direccionEntrega", "clienteRfc"]}
                        label="RFC"
                        max={50}
                        margin
                        pattern
                        tooltip="RFC / Tax ID del cliente para esta dirección"
                        {...layoutHalf}
                      >
                        <InputItem placeholder="Ej: NL000111222B01" width="100%" />
                      </FormItem>
                    </Col>
                  </Row>
                  <Row gutter={8}>
                    <Col span={12}>
                      <FormItem
                        name={["direccionEntrega", "referencia"]}
                        label="Referencia"
                        max={50}
                        margin
                        pattern
                        required={this.props.addendaViscofan}
                        rules={this.props.addendaViscofan ? [{ required: true, message: "La Referencia es obligatoria para Viscofan" }] : []}
                        tooltip={{ title: this.props.addendaViscofan ? "La Referencia es la Planta de Entrega, ejemplo: SLP / ZAC" : "Referencia de la dirección, ejemplo: CUARTO1, C1, etc" }}
                        {...layoutHalf}
                      >
                        <InputItem placeholder="Referencia" width="100%" />
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem
                        name={["direccionEntrega", "destino"]}
                        label="Destino"
                        max={50}
                        margin
                        pattern
                        {...layoutHalf}
                      >
                        <InputItem placeholder="Destino" width="100%" />
                      </FormItem>
                    </Col>
                  </Row>

                  <Row gutter={8}>
                    <Col span={12}>
                      <FormItem
                        name={["direccionEntrega", "embarque"]}
                        label="Embarque"
                        max={50}
                        margin
                        pattern
                      >
                          <InputItem
                              placeholder="Embarque"
                          />
                      </FormItem>
                    </Col>
                  </Row>

                  {this.props.addendaMabe && (
                    <FormItem name={["direccionEntrega", "plantaEntregaId"]} label="Planta" margin {...layoutFull}>
                      <SelectItem
                        placeholder="Seleccionar planta de entrega"
                        showSearch
                        filterOption={false}
                        mostrarCarga
                        loading={this.props.loadingPlantasEntrega?.["direccionEntrega"]}
                        notFoundContent={
                          this.props.loadingPlantasEntrega?.["direccionEntrega"] ? "Buscando...." : "Sin resultados"
                        }
                        onSearch={(val) => this.props.onSearchPlantaEntrega(val, "direccionEntrega")}
                        onFocus={() => this.props.onSearchPlantaEntrega("", "direccionEntrega")}
                      >
                        {
                          !this.props.objetoPlantasEntrega?.["direccionEntrega"] ||
                            this.props.objetoPlantasEntrega["direccionEntrega"].length === 0
                            ? <Option disabled>Escribe ID o Centro de Distribución</Option>
                            : this.props.objetoPlantasEntrega["direccionEntrega"]
                        }
                      </SelectItem>
                    </FormItem>
                  )}

                  <Row gutter={8}>
                    <Col span={14}>
                      <FormItem
                        name={["direccionEntrega", "calle"]}
                        label="Calle"
                        max={200}
                        margin
                        pattern
                        labelCol={{ span: 7 }}
                        wrapperCol={{ span: 17 }}
                      >
                        <InputItem placeholder="Calle" width="100%" />
                      </FormItem>
                    </Col>
                    <Col span={5}>
                      <FormItem
                        name={["direccionEntrega", "numeroCalle"]}
                        label="No."
                        margin
                        labelCol={{ span: 9 }}
                        wrapperCol={{ span: 15 }}
                      >
                        <InputItem placeholder="Ext." numeroCalle width="100%" />
                      </FormItem>
                    </Col>
                    <Col span={5}>
                      <FormItem
                        name={["direccionEntrega", "numeroInterior"]}
                        label="Int."
                        margin
                        pattern
                        labelCol={{ span: 9 }}
                        wrapperCol={{ span: 15 }}
                      >
                        <InputItem placeholder="Int." width="100%" />
                      </FormItem>
                    </Col>
                  </Row>

                  <Row gutter={8}>
                    <Col span={9}>
                      <FormItem name={["direccionEntrega", "coloniaId"]} label="C.P." margin labelCol={{ span: 10 }} wrapperCol={{ span: 13.5 }}>
                        <SelectItem placeholder="C.P." onSearch={this.props.onSearchColonia} onSelect={this.props.onSelectColoniaId}>
                          {this.props.objetoColonias}
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={15}>
                      <FormItem
                        name={["direccionEntrega", "colonia"]}
                        label="Colonia"
                        margin
                        pattern
                        labelCol={{ span: 4.5 }}
                        wrapperCol={{ span: 19.5 }}
                      >
                        <InputItem placeholder="Colonia" width="100%" />
                      </FormItem>
                    </Col>
                  </Row>

                  <Row gutter={8}>
                    <Col span={8}>
                      <FormItem name={["direccionEntrega", "municipioId"]} label="Mpio." margin labelCol={{ span: 11 }} wrapperCol={{ span: 13 }}>
                        <SelectItem placeholder="Municipio" onChange={(e) => this.props.onChangeMunicipio(e)}>{this.props.objetoMunicipios}</SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem name={["direccionEntrega", "estadoId"]} label="Edo." margin labelCol={{ span: 11 }} wrapperCol={{ span: 13 }}>
                        <SelectItem placeholder="Estado" onChange={(e) => this.props.onChangeEstado(e)}>{this.props.objetoEstados}</SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem name={["direccionEntrega", "paisId"]} label="País" margin labelCol={{ span: 11 }} wrapperCol={{ span: 13 }}>
                        <SelectItem placeholder="País">{this.props.objetoPaises}</SelectItem>
                      </FormItem>
                    </Col>
                  </Row>
                </BoxItem>
              </Col>

              {/* SECCIÓN CONTACTO */}
              <Col span={12} xs={24} lg={12}>
                <HeaderItem>CONTACTO EN DIRECCION</HeaderItem>
                <BoxItem>
                  <FormItem
                    name={["direccionEntrega", "descripcion"]}
                    label="Nombre"
                    margin
                    pattern
                    {...layoutFull}
                  >
                    <InputItem placeholder="Nombre del contacto" width="100%" />
                  </FormItem>
                  <Row gutter={8}>
                    <Col span={12}>
                      <FormItem
                        label="Teléfono"
                        name={["direccionEntrega", "telefono"]}
                        number
                        margin
                        {...layoutHalf}
                      >
                        <InputNumberItem placeholder="Teléfono" celular />
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem
                        label="Correo"
                        name={["direccionEntrega", "correo"]}
                        pattern
                        max={200}
                        email
                        margin
                        {...layoutHalf}
                      >
                        <InputItem placeholder="Correo electrónico" width="100%" />
                      </FormItem>
                    </Col>
                  </Row>
                  <FormItem
                    name={["direccionEntrega", "observaciones"]}
                    label="Notas"
                    margin
                    pattern
                    {...layoutFull}
                  >
                    <InputItem placeholder="Observaciones de la entrega" width="100%" />
                  </FormItem>
                </BoxItem>
              </Col>
            </Row>
          </Spin>
        </ModalItem>
      </>
    );
  }
}

export default TabEntregaDireccion;